import { seriesName } from '../seriesName';
import Content from './content';

const data: any = {
    seriesName,
    Content,
};

export default Content;
